import React from 'react';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';

export default function Copyright() {
  return (
    <Box>
        <Box display="flex"
              alignItems="center"
              justifyContent="center">
            <Typography variant="body2" align="center" >
              <Link href="https://www.gtmdocs.com/privacy-policy">
                Privacy Policy
              </Link>
              &nbsp; | &nbsp;
              <Link href="https://www.gtmdocs.com/terms-of-service">
                Terms of Use
              </Link>
            </Typography>
        </Box>
        <Box display="flex"
              alignItems="center"
              justifyContent="center">
        <Typography variant="body2" align="center" >
          <Link color="inherit" href="https://www.georgejeng.com/">
            GTM Docs created by Insightful Tech, LLC
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}
